import { Col, Form, Row } from 'antd'
import LeftArrowIcon from 'components/icons/LeftArrowIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import { InstituteData } from 'modules/Auth/actions'
// import CancelDriveDrawer from 'modules/Drive/Partials/CancelDriveDrawer'
import ConfirmDriveDrawer from 'modules/Drive/Partials/ConfirmDriveDrawer'
// import DriveInfoDrawer from 'modules/Drive/Partials/DriveInfoDrawer'
import ScheduleDriveDrawer from 'modules/Drive/Partials/ScheduleDriveDrawer'
import ViewReportDrawer from 'modules/Drive/Partials/ViewReportDrawer'
import DriveInfoDetails from 'modules/DriveInfo/Partials/Details'
import DriveInfoTable from 'modules/DriveInfo/Partials/DriveInfoTable/index'
import {
  JobDetailsSpan,
  RoleSpan,
} from 'modules/Roles/Partials/ViewIndividualRole/Style/style'
import AddNewStudentDrawer from 'modules/Students/Partials/AddNewStudentDrawer'
import SettingsDrawer from 'modules/Students/Partials/SettingsDrawer'
import StudentsBulkUpload from 'modules/Students/Partials/StudentsBulkUpload'
import { SectionWrapper, TopHeader } from 'modules/Students/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import instRequest from 'utils/instRequest'

const DriveInfo = ({
  studentDriveList,
  studentsList,
  UserDriveList,
  ViewDriveList,
  getStudentsListData,
  createStudent,
  getSingleStudentData,
  singleStudentData,
  deleteStudent,
  editStudent,
  studentsMetrics,
  degreeList,
  blacklistStudent,
  activeInactivateStatus,
  deleteBulkStudents,
  reInviteStudent,
  getDegreeData,
  bulkUploadStudents,
  selectedDriveInfo,
  getStudentDriveListData,
  getViewDriveInfo,
  ...props
}) => {
  const [createEditForm] = Form.useForm()

  const [infoDrawer, setInfoDrawer] = useState(false)
  const [cancelDrawer, setCancelDrawer] = useState(false)
  const [scheduleDrawer, setScheduleDrawer] = useState(false)
  const [confirmDrawer, setConfirmDrawer] = useState(false)
  const [isReschedule, setIsReschedule] = useState(false)
  const [viewReportDrawer, setViewReportDrawer] = useState(false)
  const [selectedDrive, setSelectedDrive] = useState()
  const navigate = new useNavigate()
  const closeCancelDrawerHandler = flag => {
    setCancelDrawer(false)
    setInfoDrawer(false)
    if (flag) {
      setCurrentPage(0)
    }
  }
  useEffect(() => {
    setSelectedDrive(ViewDriveList)
  }, [ViewDriveList?.details?.[0]])

  const [cardsData, setCardsData] = useState([])
  useEffect(() => {
    setCardsData([
      {
        key: 1,
        icon: <UserDefaultIcon />,
        text: 'Applied',
        value: selectedDrive?.applied,
        filter: 'status=2',
        isSelected: false,
      },
      {
        key: 2,
        icon: <UserDefaultIcon />,
        text: 'ShortListed',
        value: selectedDrive?.shortlisted,
        filter: 'status=-2',
        isSelected: false,
      },
      {
        key: 3,
        icon: <UserDefaultIcon />,
        text: 'Offer Released ',
        value: selectedDrive?.offerReleased,
        filter: 'completionStart=0&completionEnd=99',
        isSelected: false,
      },
    ])
  }, [selectedDrive])
  const [newStudentDrawer, setNewStudentDrawer] = useState(false)
  const [settingDrawer, setSettingDrawer] = useState(false)
  const [uploadDrawer, setUploadDrawer] = useState(false)
  const [isEditingForm, setIsEditingForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentStudentId, setCurrentStudentId] = useState('')
  const [countryCode, setCountryCode] = useState('+91')

  const [studentType, setStudentType] = useState('')
  const [studentDOB, setStudentDOB] = useState('')
  const [studentBatch, setStudentBatch] = useState({
    startedOn: '',
    endedOn: '',
  })

  const [marksType, setMarksType] = useState('')
  const [specialization, setSpecialization] = useState([])

  const [urlQuery, setUrlQuery] = useState('')
  const [sortQuery, setSortQuery] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [selectedStudents, setSelectedStudents] = useState([])

  const dateFormat = 'DD/MM/YYYY'

  const dispatch = useDispatch()
  const instituteData = useSelector(state => state.auth.instituteDetails)
  const instituteId = useSelector(state => state.auth.instituteCampusId)

  useEffect(() => {
    getInstituteDetails()
  }, [])

  let search = window.location.search
  let param = new URLSearchParams(search)
  const id = param.get('id')
  const roleId = param.get('roleId')

  useEffect(() => {
    if (urlQuery) {
      if (sortQuery) {
        getStudentDriveListData(
          id,
          setLoading,
          roleId,
          `${urlQuery}&pageLimit=10&pageNo=${currentPage}&${sortQuery}`
        )
      } else {
        getStudentDriveListData(
          id,
          setLoading,
          roleId,
          `${urlQuery}&pageLimit=10&pageNo=${currentPage}`
        )
      }
    } else {
      if (sortQuery) {
        getStudentDriveListData(
          id,
          setLoading,
          roleId,
          `pageLimit=10&pageNo=${currentPage}&${sortQuery}`
        )
      } else {
        getStudentDriveListData(
          id,
          setLoading,
          roleId,
          `pageLimit=10&pageNo=${currentPage}`
        )
      }
      getViewDriveInfo(id)
    }
  }, [urlQuery, currentPage, instituteData, sortQuery])

  const getInstituteDetails = async () => {
    if (instituteData?.id) return
    try {
      const data = await instRequest.get(`institutes/${instituteId}`)
      if (data?.data?.data?.instituteCampus) {
        dispatch(InstituteData(data?.data?.data?.instituteCampus[0]))
        getDegreeData()
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (isEditingForm) {
      let dob = singleStudentData?.studentPersonalProfile?.dob
      if (singleStudentData?.studentPersonalProfile?.dob && !singleStudentData?.studentPersonalProfile?.dob.includes('/')) {
        dob = new Date(singleStudentData?.studentPersonalProfile?.dob)
        dob = `${dob.getDate()}/${dob?.getMonth() + 1}/${dob?.getFullYear()}`
      }
      setStudentDOB(dob)
      let mobileCode =
        singleStudentData?.studentPersonalProfile?.phoneNumber?.split(' ')[0]
      setCountryCode(mobileCode)
      setStudentBatch({
        startedOn: singleStudentData?.currentCourse?.startedOn,
        endedOn: singleStudentData?.currentCourse?.endedOn,
      })
      setStudentType(singleStudentData?.currentCourse?.admissionType)
      setMarksType({
        examType: singleStudentData?.currentCourse?.examType,
        duration: singleStudentData?.currentCourse?.duration,
        degreeStreamMapId: singleStudentData?.currentCourse?.degreeStreamMapId,
        type: singleStudentData?.currentCourse?.educationLevel,
      })
      let studentDob = singleStudentData?.studentPersonalProfile?.dob?.trim()
      studentDob = studentDob.split('/')
      if (studentDob.length > 1) {
        studentDob = `${studentDob[2]}-${studentDob[1]}-${studentDob[0]}`
      } else {
        studentDob = singleStudentData?.studentPersonalProfile?.dob
      }
      createEditForm.setFieldsValue({
        firstName: singleStudentData?.firstName,
        lastName: singleStudentData?.lastName,
        uniRollNo: singleStudentData?.uniRollNo || '',
        dob: studentDob ? moment(studentDob) : '',
        type: singleStudentData?.currentCourse?.admissionType,
        previous_college: singleStudentData?.currentCourse?.previousCollege,
        previous_university:
          singleStudentData?.currentCourse?.previousUniversity,
        degree: singleStudentData?.currentCourse?.degree,
        department: singleStudentData?.currentCourse?.department,
        batch: [
          moment(parseInt(singleStudentData?.currentCourse?.startedOn)),
          moment(parseInt(singleStudentData?.currentCourse?.endedOn)),
        ],
        email: singleStudentData?.admin?.email,
        contactNumber:
          singleStudentData?.studentPersonalProfile?.phoneNumber?.split(' ')[1],
        noOfArrears: singleStudentData?.currentCourse?.noOfArrears,
        marks: singleStudentData?.currentCourse?.marks,
      })
    }
  }, [singleStudentData])

  const onEditStudent = id => {
    setCurrentStudentId(id)
    setIsEditingForm(true)
    setNewStudentDrawer(true)
    getSingleStudentData(id)
  }

  const onSubmitFormData = data => {
    let newDob = ''
    if (studentDOB) {
      newDob = studentDOB.split('/')
      setStudentDOB(`${newDob[2]}-${newDob[1]}-${newDob[0]}`)
      newDob = `${newDob[2]}-${newDob[1]}-${newDob[0]}`
    }
    let startedOn = studentBatch?.startedOn
    let endedOn = studentBatch?.endedOn
    if (isNaN(startedOn)) {
      if (!startedOn?.includes('-')) {
        startedOn = moment(parseInt(startedOn)).format('YYYY-MM')
      }
      if (!endedOn?.includes('-')) {
        endedOn = moment(parseInt(endedOn)).format('YYYY-MM')
      }
    } else {
      startedOn = moment(parseInt(startedOn)).format('YYYY-MM')
      endedOn = moment(parseInt(endedOn)).format('YYYY-MM')
    }

    const reqData = {
      admin: {
        email: data?.email,
        phoneNumber: data?.contactNumber,
        firstName: data?.firstName.trim(),
        lastName: data?.lastName.trim(),
        countryCode: countryCode.replaceAll('+', ''),
      },
      student: {
        uniRollNo: data?.uniRollNo,
        batch: `${startedOn}-${endedOn}`,
        instituteCampusName: instituteData?.campusName,
      },
      studentPersonalProfile: {
        contactNumber: data?.contactNumber,
      },
      currentCourse: {
        admissionType: data?.type,
        previousCollege:
          data?.type == 'transferred' ? data?.previous_college : null,
        previousUniversity:
          data?.type == 'transferred' ? data?.previous_university : null,
        degree: data?.degree,
        department: data?.department,
        examType: marksType?.examType,
        duration: marksType?.duration,
        educationLevel:
          marksType?.type?.toLowerCase() == 'p.g.diploma'
            ? 'p_g_diploma'
            : marksType?.type?.toLowerCase(),
        specialisation: data?.specialisation,
        startedOn: Date.parse(new Date(startedOn)),
        endedOn: Date.parse(new Date(endedOn)),
        marks: data?.marks?.map((item, index) => {
          return {
            order: `${index + 1}`,
            mark: Number(item?.mark),
          }
        }),
        degreeStreamMapId: marksType?.degreeStreamMapId,
        noOfArrears: Number(data?.noOfArrears),
        attendanceBacklisted: false,
        conductBacklisted: false,
        collegeFeeBacklisted: false,
      },
      education: [],
      resume: {},
    }
    let payLoad = { ...reqData }
    if (studentDOB) {
      payLoad.admin.dob = moment(newDob).format('YYYY-MM-DD')
      payLoad.studentPersonalProfile.dob = moment(newDob).format('YYYY-MM-DD')
    }
    if (specialization?.id) {
      payLoad.currentCourse['specialisationId'] = specialization.id
    }
    if (isEditingForm) {
      editStudent(currentStudentId, payLoad, setNewStudentDrawer, onClearAll)
    } else {
      createStudent(payLoad, setNewStudentDrawer, onClearAll)
    }
  }

  const onClearAll = () => {
    createEditForm.resetFields()
    setIsEditingForm(false)
    setStudentType('')
    setCurrentStudentId('')
    setStudentDOB('')
    setStudentBatch({
      startedOn: '',
      endedOn: '',
    })
    setCountryCode('+91')
  }

  const onFilerChange = query => {
    setUrlQuery(query)
  }
  const onSortingChanged = query => {
    setSortQuery(query)
  }

  const openConfirmDrawer = () => {
    setConfirmDrawer(true)
    setScheduleDrawer(false)
    setInfoDrawer(false)
  }

  const handleArrow = () => {
    navigate('/drives')
  }

  return (
    <>
      <SectionWrapper column>
        <TopHeader alignCenter>
          <Link to="/drives">
            <LeftArrowIcon />
          </Link>
          <RoleSpan onClick={handleArrow}>Drives </RoleSpan>
          <JobDetailsSpan>/</JobDetailsSpan>
          <JobDetailsSpan> Drive Info</JobDetailsSpan>
        </TopHeader>

        <Row>
          <Col span={24}>
            <DriveInfoDetails
              id={id}
              ViewDriveList={ViewDriveList}
              cardsData={cardsData}
              infoDrawer={infoDrawer}
              selectedDrive={selectedDrive?.details?.[0]}
              setInfoDrawer={setInfoDrawer}
              onCancelDrawer={() => {
                setCancelDrawer(true)
              }}
              onScheduleDrawer={() => {
                setScheduleDrawer(true)
                setInfoDrawer(false)
              }}
              setIsReschedule={setIsReschedule}
              selectedDriveInfo={selectedDriveInfo}
            />
          </Col>
        </Row>
        <DriveInfoTable
          studentDriveList={UserDriveList}
          getStudentDriveListData={getStudentDriveListData}
          getViewDriveInfo={getViewDriveInfo}
          getSingleStudentData={getSingleStudentData}
          deleteStudent={deleteStudent}
          singleStudentData={singleStudentData}
          onEditStudent={onEditStudent}
          blacklistStudent={blacklistStudent}
          activeInactivateStatus={activeInactivateStatus}
          setUrl={onFilerChange}
          currentUrl={urlQuery}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          degreeList={degreeList}
          setSelectedStudents={setSelectedStudents}
          selectedStudents={selectedStudents}
          reInviteStudent={reInviteStudent}
          onSortValueChanged={onSortingChanged}
          loading={loading}
        />
      </SectionWrapper>
      {/* <DriveInfoDrawer
        infoDrawer={infoDrawer}
        selectedDrive={selectedDrive}
        setInfoDrawer={setInfoDrawer}
        onCancelDrawer={() => {
          setCancelDrawer(true)
        }}
        onScheduleDrawer={() => {
          setScheduleDrawer(true)
          setInfoDrawer(false)
        }}
        setIsReschedule={setIsReschedule}
        selectedDriveInfo={selectedDriveInfo}
      /> */}

      {/* <CancelDriveDrawer
        cancelDrawer={cancelDrawer}
        setCancelDrawer={closeCancelDrawerHandler}
        selectedDrive={selectedDrive}
      /> */}
      {selectedDrive?.id && (
        <ScheduleDriveDrawer
          setScheduleDrawer={setScheduleDrawer}
          onConfirmDrawer={openConfirmDrawer}
          scheduleDrawer={scheduleDrawer}
          selectedDrive={selectedDrive}
          isReschedule={isReschedule}
        />
      )}
      <ConfirmDriveDrawer
        confirmDrawer={confirmDrawer}
        setConfirmDrawer={data => {
          onConfirmDrawer(data)
        }}
        selectedDrive={selectedDrive}
        isReschedule={isReschedule}
      />
      <ViewReportDrawer
        viewReportDrawer={viewReportDrawer}
        setViewReportDrawer={setViewReportDrawer}
      />
      <AddNewStudentDrawer
        newStudentDrawer={newStudentDrawer}
        setNewStudentDrawer={setNewStudentDrawer}
        form={createEditForm}
        degreeList={degreeList}
        onSubmitFormData={onSubmitFormData}
        studentType={studentType}
        setStudentType={setStudentType}
        studentDOB={studentDOB}
        setStudentDOB={setStudentDOB}
        studentBatch={studentBatch}
        setStudentBatch={setStudentBatch}
        marksType={marksType}
        setMarksType={setMarksType}
        setSpecialization={setSpecialization}
        specialization={specialization}
        title={isEditingForm ? 'Edit & Update Student' : 'Add New Student'}
        sendButtonText={isEditingForm ? 'Update Student' : 'Add Student'}
        formId={isEditingForm ? 'edit_form' : 'add_form'}
        dateFormat={dateFormat}
        onClearAll={onClearAll}
        countryCode={countryCode}
        setCountryCode={setCountryCode}
        singleStudentData={singleStudentData}
      />

      <SettingsDrawer
        settingDrawer={settingDrawer}
        setsettingDrawer={setSettingDrawer}
      />
      <StudentsBulkUpload
        uploadDrawer={uploadDrawer}
        setUploadDrawer={setUploadDrawer}
        degreeList={degreeList}
        bulkUploadStudents={bulkUploadStudents}
        getStudentsListData={getStudentsListData}
        getStudentDriveListData={getStudentDriveListData}
      />
    </>
  )
}
export default DriveInfo
